import * as angular from "angular";
import { DataRecord } from "../models/data-record.model";
import { DataRecordService } from "../services/data-record.service";

export class DataRecordDataProvider {
    private $q: any;
    public __env: any;

    public dataRecords: DataRecord[];
    public dataRecord: DataRecord;
    public service: DataRecordService;

    constructor($q: any, DataRecordService: DataRecordService, __env: any) {
        this.$q = $q;
        this.service = DataRecordService;
        this.dataRecord = new DataRecord();
        this.__env = __env;
        this.dataRecords = null;
    }

    getAllDataRecords() {
        const deferred = this.$q.defer();
        if (this.dataRecords === null) {
            this.service.all().then(
                (response) => {
                    this.dataRecords = [];
                    let json = response["data"];
                    for (let i = 0; i < json.data.length; i++) {
                        this.dataRecords.push(new DataRecord(json.data[i]));
                    }
                    deferred.resolve(this.dataRecords);
                },
                (error) => {
                    this.dataRecords = [];
                    deferred.reject(error);
                }
            );
        } else {
            deferred.resolve(this.dataRecords);
        }
        return deferred.promise;
    }

    createDataRecord(record, html) {
        const deferred = this.$q.defer();
        record.html = html;
        this.service.create({ id: record.id }, record).then(
            (response) => {
                let json = response["data"];
                if (json.success) {
                    let newDataRecord = new DataRecord(json.data);
                    // TODO it will fix now(it must to changed)
                    newDataRecord.datarecordlink = json.data.datarecordlink;
                    if (this.dataRecords != null) {
                        this.dataRecords.unshift(newDataRecord);
                    }
                    deferred.resolve(newDataRecord);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    updateDataRecord(record, html) {
        const deferred = this.$q.defer();
        record.html = html;
        this.service.update(record.id, record).then(
            (response) => {
                let json = response["data"];
                if (json.success) {
                    let newDataRecord = new DataRecord(json.data);
                    // TODO it will fix now(it must to changed)
                    newDataRecord.datarecordlink = json.data.datarecordlink;
                    if (this.dataRecords != null) {
                        this.dataRecords.unshift(newDataRecord);
                    }
                    deferred.resolve(newDataRecord);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getDataRecord() {
        const deferred = this.$q.defer();
        this.service.info().then(
            (response) => {
                let json = response["data"];
                if (json.success) {
                    deferred.resolve(new DataRecord(json.data));
                } else if (json.message == "No data found") {
                    deferred.resolve(null);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getDataRecordURL(id) {
        const deferred = this.$q.defer();
        this.service.download({ id: id }).then(
            (response) => {
                let json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data.attributes.datarecordlink);
                } else if (json.message == "No data found") {
                    deferred.resolve(null);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    clearAll() {
        this.dataRecords = null;
    }
}

angular
    .module("vcDataProvider")
    .service("DataRecordDataProvider", DataRecordDataProvider);
